import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { ProposalsService } from 'src/app/services/api/proposals.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-proposal-steps-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './proposal-steps-index-page.component.html',
  styleUrl: './proposal-steps-index-page.component.scss'
})
export class ProposalStepsIndexPageComponent {
list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected proposalsService: ProposalsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Proposal Steps',
      cardTitle: 'Manage Proposal Steps',
      addNewItemButton: {
        type: 'success',
        title: 'Add Proposal Steps',
        onClick: () => {
          this.routeService.proposalStepsCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),          
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View proposal step details',
                onClick: (item: any) => {
                  this.routeService.proposalStepsDetail(item.proposalStepId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit proposal step',
                onClick: (item: any) => {
                  this.routeService.proposalStepsUpdate(item.proposalStepId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete proposal step',
                onClick: (item: any) => {                  
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((proposalStep: any) => proposalStep.proposalStepId !== proposalStep.proposalStepId);
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.proposalsService.listSettingsProposalSteps(options),
      responseListModelName: 'proposalSteps',
    }
  }
}
